var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpsetFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_468_2985)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 25,
    height: 25,
    rx: 6.25415,
    fill: "#FFBF08",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4559 7.95978C9.20939 7.95978 8.02629 7.49499 7.11785 6.63936C6.96996 6.50203 6.9594 6.26964 7.09672 6.12175C7.23404 5.97386 7.46644 5.96331 7.61432 6.10063C8.38545 6.81894 9.38897 7.22034 10.4453 7.22034C11.4805 7.22034 12.4735 6.8295 13.2446 6.13232C13.3925 5.99499 13.6249 6.00556 13.7622 6.15345C13.8995 6.30133 13.889 6.53372 13.7411 6.67105C12.8537 7.50555 11.6812 7.95978 10.4559 7.95978Z",
    fill: "#060000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0509 7.95964C19.8256 7.95964 18.6531 7.50542 17.7552 6.67091C17.6073 6.53359 17.5967 6.3012 17.734 6.15331C17.8714 6.00543 18.1038 5.99486 18.2517 6.13218C19.0122 6.82937 20.0052 7.22021 21.0509 7.22021C22.1073 7.22021 23.1108 6.8188 23.8819 6.1005C24.0298 5.96317 24.2622 5.96317 24.3995 6.12162C24.5368 6.2695 24.5368 6.5019 24.3784 6.63922C23.4805 7.49486 22.2974 7.95964 21.0509 7.95964Z",
    fill: "#060000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4242 14.2869C12.2911 14.2869 13.8045 12.7735 13.8045 10.9066C13.8045 9.03977 12.2911 7.52637 10.4242 7.52637C8.55734 7.52637 7.04395 9.03977 7.04395 10.9066C7.04395 12.7735 8.55734 14.2869 10.4242 14.2869Z",
    fill: "#060000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0051 10.907C11.7811 10.907 12.4101 10.278 12.4101 9.50209C12.4101 8.72617 11.7811 8.09717 11.0051 8.09717C10.2292 8.09717 9.60022 8.72617 9.60022 9.50209C9.60022 10.278 10.2292 10.907 11.0051 10.907Z",
    fill: "#FFFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44172 12.5231C9.71008 12.5231 9.92764 12.3055 9.92764 12.0372C9.92764 11.7688 9.71008 11.5513 9.44172 11.5513C9.17336 11.5513 8.95581 11.7688 8.95581 12.0372C8.95581 12.3055 9.17336 12.5231 9.44172 12.5231Z",
    fill: "#FFFEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0932 14.2869C22.96 14.2869 24.4734 12.7735 24.4734 10.9066C24.4734 9.03977 22.96 7.52637 21.0932 7.52637C19.2263 7.52637 17.7129 9.03977 17.7129 10.9066C17.7129 12.7735 19.2263 14.2869 21.0932 14.2869Z",
    fill: "#060000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5122 10.907C21.2881 10.907 21.9172 10.278 21.9172 9.50209C21.9172 8.72617 21.2881 8.09717 20.5122 8.09717C19.7363 8.09717 19.1073 8.72617 19.1073 9.50209C19.1073 10.278 19.7363 10.907 20.5122 10.907Z",
    fill: "#FFFEFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.065 12.5231C22.3334 12.5231 22.5509 12.3055 22.5509 12.0372C22.5509 11.7688 22.3334 11.5513 22.065 11.5513C21.7967 11.5513 21.5791 11.7688 21.5791 12.0372C21.5791 12.3055 21.7967 12.5231 22.065 12.5231Z",
    fill: "#FFFEFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0932 19.0513C17.9664 19.0513 17.8502 18.9879 17.7763 18.8823C17.3326 18.1851 16.5721 17.7626 15.7481 17.7626C14.9242 17.7626 14.1636 18.1745 13.72 18.8823C13.6143 19.0513 13.3819 19.1041 13.2129 18.9985C13.0439 18.8928 12.9911 18.6604 13.0967 18.4914C13.6777 17.583 14.6707 17.0337 15.7481 17.0337C16.8362 17.0337 17.8291 17.583 18.4101 18.502C18.5157 18.671 18.4629 18.9034 18.2939 19.009C18.2305 19.0302 18.1671 19.0513 18.0932 19.0513Z",
    fill: "#060000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_2985",
    x: 0.49834,
    y: 0,
    width: 31.0033,
    height: 30.0033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.50166
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_2985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_468_2985",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsetFace);
export default __webpack_public_path__ + "static/media/upset-face.cb5eb899d2a02d5370cfb92b6cb56c93.svg";
export { ForwardRef as ReactComponent };